import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

/* Custom */
import eventBus, { EVENTS } from '~/custom/eventBus';

/* Icons */
import heartIcon from '~/../symbols/heart.svg';

/* Common */
import { Icon } from '~/components/common';

/* Config */
import { reactToastifyConfig } from '~/config';

export default function FavoritesCount({ favoritesUrl, getFavoritesUrl }) {
    const [favoritesCount, setFavoritesCount] = useState(0);

    useEffect(() => {
        toast.configure(reactToastifyConfig);
        fetchFavorites();

        // Event listener toevoegen
        const handleFavoritesUpdated = () => {
            fetchFavorites();
        };

        eventBus.on(EVENTS.FAVORITES_UPDATED, handleFavoritesUpdated);

        // Cleanup function om event listener te verwijderen
        return () => {
            eventBus.off(EVENTS.FAVORITES_UPDATED, handleFavoritesUpdated);
        };
    }, []);

    const fetchFavorites = async () => {
        try {
            const response = await axios.get(getFavoritesUrl);
            const favorites = response.data.vehicles;
            if (favorites) {
                setFavoritesCount(favorites.filter((vehicle) => !vehicle.removed).length);
            } else {
                toast.error('Er is iets verkeerd gegaan bij het ophalen van favorieten.');
            }
        } catch (error) {
            toast.error('Er is iets verkeerd gegaan, probeer het nogmaals.');
        }
    };

    return (
        <a href={favoritesUrl} id="favorites-nav-item">
            <div className="icon-favorites-wrapper">
                <Icon
                    type="heart"
                    size="24"
                    className="icon-favorites"
                    url={heartIcon}
                />
                <div className="favorites-amount-wrapper">
                    <div className="amount">
                        <span className="number">{favoritesCount}</span>
                    </div>
                </div>
            </div>
        </a>
    );
}
